import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import RealTimeTrackingForm from "./RealTimeTrackingComponents/RealTimeTrackingForm";

import { useAddRealTimeTrackingMutation } from "store/services/realTimeTrackingApi";

const RealTimeTrackingCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Real-Time Tracking", path: "/app/crm/realtime-tracking/list" },
    { title: "New Tracking" },
  ];

  // RTK query hook for adding a real-time tracking entry
  const [addRealTimeTracking, { isLoading }] = useAddRealTimeTrackingMutation();

  const handleCreateRealTimeTracking = async (data) => {
    try {
      const { _id } = await addRealTimeTracking(data).unwrap();
      toast.success("Real-time tracking successfully created!");
      navigate(`/app/crm/realtime-tracking/${_id}/detail`); // Navigate to the newly created tracking detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create real-time tracking!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <RealTimeTrackingForm
          isBusy={isLoading}
          onSubmit={handleCreateRealTimeTracking}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default RealTimeTrackingCreateScreen;
